import { Box, Card, Flex, Text } from "@chakra-ui/react";
import {
  Button,
  Calendar,
  CalendarCell,
  CalendarGrid,
  CalendarProps,
  DateValue,
  Heading,
} from "react-aria-components";
import "./calendar.css";
import { isSameDay } from "date-fns";

interface ObservationsCalendarProps extends CalendarProps<DateValue> {
  activeDates: string[];
  hideBelow?: string;
  outplantingDate?: string | null;
}

const ObservationsCalendar: React.FC<ObservationsCalendarProps> = ({
  activeDates,
  hideBelow,
  outplantingDate,
}) => {
  return (
    <Card.Root overflow="hidden" hideBelow={hideBelow} size="sm">
      <Card.Body>
        <Calendar
          aria-label="Appointment date"
          style={{ width: "100%", marginInline: "auto" }}
        >
          <header>
            <Button slot="previous">◀</Button>
            <Heading />
            <Button slot="next">▶</Button>
          </header>
          <CalendarGrid style={{ width: "100%" }}>
            {(date) => {
              const isActive = activeDates.includes(
                new Date(
                  `${date.year}-${date.month}-${date.day}`,
                ).toLocaleDateString(),
              );
              const isOutplantingDate = outplantingDate
                ? isSameDay(
                  new Date(`${date.year}-${date.month}-${date.day}`),
                  new Date(outplantingDate),
                )
                : false;
              return (
                <CalendarCell
                  key={`${date.year}-${date.month}-${date.day}`}
                  date={date}
                  style={{
                    backgroundColor: isActive
                      ? "var(--chakra-colors-blue-500)"
                      : isOutplantingDate
                        ? "var(--chakra-colors-green-500)"
                        : "white",
                    color:
                      isActive || isOutplantingDate
                        ? "white"
                        : "var(--chakra-colors-gray-500)",
                    borderRadius:
                      isActive || isOutplantingDate ? "99999px" : "0",
                    textAlign: "center",
                    marginInline: "auto",
                  }}
                />
              );
            }}
          </CalendarGrid>
        </Calendar>
        <Flex
          gap="2"
          alignItems="center"
          maxW="380px"
          marginInline="auto"
          mt="4"
          ml="4"
        >
          <Box
            display="inline-block"
            borderRadius="full"
            width="4"
            height="4"
            bg="blue.500"
            borderColor="blue.500"
          />
          <Text fontSize="xs">Observations</Text>
          {outplantingDate && (
            <>
              <Box
                display="inline-block"
                borderRadius="full"
                ml="3"
                width="4"
                height="4"
                bg="green.500"
                borderColor="green.500"
              />
              <Text fontSize="xs">Est. Outplanting</Text>
            </>
          )}
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};

export default ObservationsCalendar;
